import { ThemeColors } from '~/themes/colors'

interface FeedbackToastColors {
  container: {
    border: ThemeColors
    boxShadow: ThemeColors
    background: ThemeColors
  }
  header: {
    fontColor: ThemeColors
  }
  message: {
    fontColor: ThemeColors
  }
}

export const feedbackToastColors: FeedbackToastColors = {
  container: {
    border: { default: 'gray.400' },
    boxShadow: { default: 'mask.gray.1300.10' },
    background: { default: 'white' },
  },
  header: {
    fontColor: { default: 'gray.1300' },
  },
  message: {
    fontColor: { default: 'gray.1300' },
  },
}
